export const marketplaceSettingsSection = "/marketplace-settings/";

export const marketplaceSettingsPath = marketplaceSettingsSection;

export const marketplaceSettingsUrl = () => marketplaceSettingsPath;
